import { type TenantContextType, useTenant } from "@/hooks/routes/useTenant";
import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantSettingsRoot = () => {
  useProtected();
  const tenantContext = useTenant();

  return <Outlet context={{ ...tenantContext } satisfies TenantContextType} />;
};

export { SettingsPage } from "./Settings";
export { LetterHeadsRoot } from "./LetterHeadsRoot";
export { LetterHeadsPage } from "./LetterHeads";
export { LetterHeadPage } from "./LetterHead";
export { AgendaTemplatesRoot } from "./AgendaTemplatesRoot";
export { AgendaTemplatesPage } from "./AgendaTemplates";
export { AgendaTemplatePage } from "./AgendaTemplate";
